import { defineMessages } from 'react-intl';

import { insertInArray } from '@plone/volto/helpers/Utils/Utils';
import { MediaSchema } from '@fhnw/schemas/media';
import { ImageSchema } from '@plone/volto/components/manage/Blocks/Image/schema';
import baseMessages from '@fhnw/messages/base';

const messages = defineMessages({
  Video: {
    id: 'Video',
    defaultMessage: 'Video',
  },
  VideoURL: {
    id: 'Video URL',
    defaultMessage: 'Video URL',
  },
  Preview_image: {
    id: 'Preview Image URL',
    defaultMessage: 'Preview Image URL',
  },
});
export const VideoBlockSchema = (props) => {
  const media = MediaSchema(props);
  const image = ImageSchema({ formData: { url: null }, intl: props.intl });

  const schema = {
    title: props.intl.formatMessage(messages.Video),
    block: 'Video',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'url',
          'preview_image',
          'format',
          'title',
          'caption',
          'align',
          'size',
          'autoplay',
          'hide_controls',
          'force_captions',
        ],
      },
    ],
    properties: {
      url: {
        title: props.intl.formatMessage(messages.VideoURL),
        widget: 'url',
      },
      title: media.properties.image_title,
      preview_image: {
        title: props.intl.formatMessage(messages.Preview_image),
        widget: 'url',
      },
      format: media.properties.format,
      caption: media.properties.caption,
      align: {
        title: image.properties.align.title,
        widget: 'align',
        default: 'center',
        disabled: !props?.formData?.size || props?.formData?.size === 'large',
      },
      float: {
        title: props.intl.formatMessage(baseMessages.Float),
        widgetOptions: {
          frontendOptions: {
            widget: 'checkbox',
          },
        },
      },
      size: {
        title: image.properties.size.title,
        widget: 'select',
        default: 'large',
        choices: [
          ['large', props.intl.formatMessage(baseMessages.SizeLarge)],
          ['half', props.intl.formatMessage(baseMessages.SizeHalf)],
          ['third', props.intl.formatMessage(baseMessages.SizeThird)],
          ['portrait', props.intl.formatMessage(baseMessages.SizePortrait)],
        ],
      },
      autoplay: media.properties.autoplay,
      hide_controls: media.properties.hide_controls,
      force_captions: media.properties.force_captions,
    },
    required: [],
  };

  if (
    props?.formData?.size !== 'large' &&
    props?.formData?.align !== 'center'
  ) {
    schema.fieldsets[0].fields = insertInArray(
      schema.fieldsets[0].fields,
      'float',
      5,
    );
  }

  return schema;
};

export default VideoBlockSchema;
